<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import "@/assets/iconfont/iconfont.js";
export default {
  name: "App",
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data() {
    return{
      isRouterAlive: true                    //控制视图是否显示的变量
    }
  },
  created() {
    // let locale = this.$util.getCookie("locale");
    // if (locale) {
    //   this.$i18n.locale = locale;
    // }
    this.$i18n.locale = this.$util.getCookie("locale") || 'en';
  },
  methods: {
    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      })
    },
  },
};
</script>
<style lang="scss">
@import "./style/base.css";
@import "./style/common.css";
@import "./assets/iconfont/iconfont.css";

#app {
 font-family: -apple-system, "PingFang SC", "Hiragino Sans GB",
    "Helvetica Neue", Helvetica, Arial, "Microsoft YaHei", "WenQuanYi Micro Hei",
    sans-serif;  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0f1e33;
  margin: 0;
  padding: 0;
}
@media screen and (min-width: 768px) {
  html,
  body {
    padding: 0;
    margin: 0;
    min-width: 1280px;
  }
}
@media screen and (max-width: 768px) {
  .nav-tab {
    margin: 12px 0px 48px !important;
    .el-tabs__nav-scroll {
      margin: 0 !important;
    }
  }
  .el-dialog {
    width: 80% !important;
  }
  .affix {
    display: none;
  }
  .pagebox {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue